import { render, staticRenderFns } from "./InformationSquareMetersBlock.vue?vue&type=template&id=38459096&scoped=true&"
import script from "./InformationSquareMetersBlock.vue?vue&type=script&lang=js&"
export * from "./InformationSquareMetersBlock.vue?vue&type=script&lang=js&"
import style0 from "./InformationSquareMetersBlock.vue?vue&type=style&index=0&id=38459096&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38459096",
  null
  
)

export default component.exports